module.exports = __webpack_public_path__ + "static/WB5-f01bede0cae060298d160290afa02735.jpg";